<app-page-header
    title="Gestión de Roles y Accesos"
    mobileTitle="Roles"
    icon="fas fa-shield-alt"
    [showBack]="appSettings.isMobile() && showRoleDetail"
    [unifiedOnMobile]="appSettings.isMobile() && showRoleDetail"
    (back)="closeRoleDetail()">
    @if (appSettings.isMobile() && !showRoleDetail && perm.canCurrent('canCreate')) {
        <button headerExtra type="button" class="btn btn-primary btn-xs" (click)="toggleNewRoleModal()">
            <i class="fas fa-plus me-1"></i>Nuevo
        </button>
    }
</app-page-header>

<app-mobile-footer [visible]="appSettings.isMobile() && !showRoleDetail">
    <input type="search"
           class="form-control mobile-footer-search"
           placeholder="Buscar rol..."
           [(ngModel)]="roleSearch">
</app-mobile-footer>
@if (appSettings.isMobile() && showRoleDetail && mode() !== formMode.VIEW) {
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="roleForm.invalid"
        (click)="handleFormChange(roleForm.value)">
        Guardar
    </button>
</app-mobile-footer>
}

@if (!(appSettings.isMobile() && showRoleDetail)) {
<div class="row">
    <div class="col-12">
        @if (!appSettings.isMobile()) {
        <div class="panel p-3 mb-3">
            <div class="d-flex justify-content-between">
                <div class="col-md-4">
                    <ng-select [items]="catalogService.roles()" bindLabel="displayName"
                        placeholder="Seleccione un rol..." [(ngModel)]="selectedRole"
                        [compareWith]="compareRoles" (change)="onRoleSelected($event)">
                    </ng-select>
                </div>
                <div>
                    @if (perm.canCurrent('canCreate')) {
                    <button class="btn btn-primary d-block w-100" (click)="toggleNewRoleModal()">
                        <i class="fas fa-plus me-1"></i> Nuevo Rol
                    </button>
                    }
                </div>
            </div>
        </div>
        } @else {
        <div class="mobile-requests-container">
            <div class="d-flex justify-content-between align-items-center mb-2 px-1">
                <span class="small text-muted fw-bold text-uppercase">
                    REGISTROS ({{ filteredCatalogRoles().length }})
                </span>
            </div>
            <div class="mobile-cards-scroll">
                @for (role of filteredCatalogRoles(); track (role.slug ?? role.id)) {
                    <app-list-card
                        [isShortcut]="true"
                        (click)="onRoleSelected(role)">
                        <div cardTitle class="fw-bold text-dark text-truncate">
                            {{ role.displayName || role.description || role.slug || role.name }}
                        </div>
                        <div cardBadge>
                            <span class="badge"
                                  [class.text-bg-success]="role.isActive !== false"
                                  [class.text-bg-secondary]="role.isActive === false">
                                {{ role.isActive === false ? 'Inactivo' : 'Activo' }}
                            </span>
                        </div>
                        <div class="text-muted small">{{ role.slug || role.name }}</div>
                        <div cardExtra>Nivel {{ role.level ?? '—' }}</div>
                    </app-list-card>
                } @empty {
                    <div class="card border-0 shadow-sm p-4 text-center my-2">
                        <i class="fas fa-shield-alt fa-3x text-muted opacity-50 mb-2"></i>
                        <h6 class="text-muted mb-1">Sin roles</h6>
                    </div>
                }
            </div>
        </div>
        }
    </div>
</div>
}

@if (!appSettings.isMobile() || showRoleDetail) {
<div class="row">
    <div class="col-12">
        @if(selectedRole){
        <div class="panel p-3 mb-3 animate__animated animate__fadeIn">
            <app-role-form [roleForm]="roleForm" [(mode)]="mode" (formChange)="handleFormChange($event)">
            </app-role-form>

            @if(mode() !== formMode.VIEW && !appSettings.isMobile()){
            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" (click)="handleFormChange(roleForm.value)">
                    <i class="fas fa-save me-1"></i> Guardar Cambios
                </button>
                &nbsp;
                <button class="btn btn-outline-secondary" (click)="mode.set(formMode.VIEW)">
                    <i class="fas fa-times me-1"></i> Cancelar
                </button>
            </div>
            }
        </div>

        <div class="animate__animated animate__fadeInUp">
            <app-role-menus-list
                [menus]="selectedRole.menus || []"
                [canManage]="perm.canCurrent('canUpdate') && !!(selectedRole?.slug ?? selectedRole?.id) && !selectedRole?.isNew"
                [editing]="menusEditing()"
                (onEdit)="startMenusEdit()"
                (onSave)="saveMenusDraft()"
                (onCancel)="cancelMenusEdit()"
                (onRemove)="removeMenu($event)"
                (onAdd)="toggleMenuModal()"
                (onPermissionChange)="onPermissionChange($event)"
                (onActionsChange)="onActionsChange($event)">
            </app-role-menus-list>
        </div>

        } @else if (!appSettings.isMobile()) {
        <div class="panel animate__animated animate__fadeIn">
            <div class="panel-body d-flex flex-column align-items-center justify-content-center text-center p-5">
                <div class="mb-3 p-4  d-inline-flex align-items-center justify-content-center">
                    <i class="fas fa-shield-alt text-muted opacity-25 fa-3x"></i>
                </div>
                <h4 class="text-muted fw-bold mb-2">Esperando selección del Rol</h4>
                <div class="text-muted small">Utiliza el selector de la parte superior para cargar y configurar un rol
                    existente.
                </div>
            </div>
        </div>
        }
    </div>
</div>
}

<!-- Modal para añadir menús -->
<ng-template #menuModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Asociar Menús / Accesos</h4>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-role-menus-form #menusForm [menusAll]="menuOptions()"
            [currentMenusIds]="getIds(selectedRole.menus)">
        </app-role-menus-form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-white" (click)="modal.dismiss()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="saveMenusFromModal(menusForm)">Guardar Cambios</button>
    </div>
</ng-template>

<!-- Modal para Nuevo Rol -->
<ng-template #newRole let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Nuevo Rol</h4>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-role-form #roleFormModal [roleForm]="roleForm" [(mode)]="mode" (formChange)="handleFormChange($event)">
        </app-role-form>
        <hr class="my-3">
        <app-role-menus-form #menusForm [menusAll]="menuOptions()"
            [currentMenusIds]="getIds(selectedRole.menus)">
        </app-role-menus-form>
        <p class="form-text text-muted mb-0">
            Los menús del alta quedan solo con <strong>Leer</strong>. Crear / Editar / Eliminar se marcan después en Editar permisos.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-white" (click)="modal.dismiss()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="createRoleWithMenus(roleFormModal, menusForm)">Crear Rol</button>
    </div>
</ng-template>
